import React from "react";
import { Navigate } from "react-router-dom";
import { RequireRole } from "../../app/router/RequireRole";
import { DiagnosticPage } from "./pages/DiagnosticPage";
import { MyClassesPage } from "./pages/MyClassesPage";
import { MyBalancePage } from "./pages/MyBalancePage";

/**
 * Student feature routes — TASK-14 (R6: owned exclusively by src/features/student/).
 *
 * All routes are under /:slug/app/mi-espacio/* and protected by RequireRole(['STUDENT']).
 * Registered in AppRouter.js by adding:
 *   import studentRoutes from '../../features/student/routes';
 *   registry.register(studentRoutes);
 */
const studentRoutes = [
  {
    path: "/:slug/app/mi-espacio",
    element: <RequireRole roles={["STUDENT"]} />,
    children: [
      { index: true, element: <Navigate to="mis-clases" replace /> },
      { path: "diagnostico", element: <DiagnosticPage /> },
      // "Calendario" se integró en "Mis clases" (Combinado/Tarjetas/Calendario).
      { path: "calendario", element: <Navigate to="../mis-clases" replace /> },
      { path: "mis-clases", element: <MyClassesPage /> },
      { path: "mi-saldo", element: <MyBalancePage /> },
      // "Mis pagos" se integró en "Mi saldo" (saldo + historial + modal de detalle).
      { path: "mis-pagos", element: <Navigate to="../mi-saldo" replace /> },
      // "Mi progreso" se integró en el perfil (/:slug/app/perfil).
      { path: "mi-progreso", element: <Navigate to="../mis-clases" replace /> },
    ],
  },
];

export default studentRoutes;
